<template>
  <!-- 退款审核 -->
  <div class="lianxi">
    <div class="title-title">
      <span class="title">
        <Input
          placeholder="搜索"
          class="input"
          clearable
          @on-enter="financialselectOrderList"
          @on-clear="financialselectOrderList"
          v-model.trim="inputvalue"
        >
          <Icon
            type="ios-search"
            slot="prefix"
            @click="financialselectOrderList"
          />
        </Input>
      </span>
      <!-- <Select @on-change="changeSelect" v-model="selectItem" style="width:150px;color:#7F7F7F;vertical-align:middle;">
        <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select> -->
      <Select
        @on-change="changeJigouSelect"
        v-model="selectJigouItem"
        style="width:150px;color:#7F7F7F;vertical-align:middle;"
      >
        <Option
          v-for="item in jigouList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select>
    </div>
    <div class="table-cont">
      <Table
        @on-sort-change="changesort"
        stripe
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <Page
        @on-page-size-change="changepage"
        :total="tableObj.total"
        show-elevator
        show-total
        @on-change="changecurrent"
        :current="pageNum"
        :page-size="pagesize"
        show-sizer
        class="page-div-page"
      />
    </div>

    <Modal class="ivumodal" v-model="sliceIshhow" title="审核提示" footer-hide>
      <div class="ivumodal-cont" style="height:180px;">
        <div style="height:40px;line-height:40px;">
          对此退款申请订单是否通过该请求？
        </div>
        <div style="line-height:40px;">
          <RadioGroup v-model="selecTong">
            <Radio label="2">
              <span>审核通过</span>
            </Radio>
            <Radio label="3" style="margin-left:50px;">
              <span>审核不通过</span>
            </Radio>
          </RadioGroup>
          <div style="line-height:30px;">
            <Input
              clearable
              class="input"
              type="textarea"
              :rows="4"
              placeholder="请输入审核说明"
              v-model.trim="hospitalAuditMessage"
            ></Input>
          </div>
        </div>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" ghost type="success" @click="sliceIshhow = false"
          >取消</Button
        >
        <Button class="btn sure" ghost type="success" @click="ok">确定</Button>
      </div>
    </Modal>

    <Modal
      class="ivumodal"
      footer-hide
      width="800"
      v-model="seeShow"
      title="查看用户退款详情"
    >
      <div>
        <Form ref="xiugai" :label-width="250" v-model="dataObj">
          <FormItem label="姓名：" prop="num" class="bumenModal-item">
            {{ dataObj.patientName }}
          </FormItem>
          <FormItem label="年龄：" prop="instructions" class="bumenModal-item">
            {{ dataObj.age }}
          </FormItem>
          <FormItem
            label="套餐名称："
            prop="instructions"
            class="bumenModal-item"
          >
            {{ dataObj.examSuiteName }}
          </FormItem>
          <FormItem
            label="退款申请时间："
            prop="instructions"
            class="bumenModal-item"
          >
            {{ dataObj.applyTime }}
          </FormItem>
          <FormItem
            label="退款申请项目："
            prop="instructions"
            class="bumenModal-item"
          >
            {{ dataObj.note || "全部" }}
          </FormItem>
          <FormItem
            label="退款金额："
            prop="instructions"
            class="bumenModal-item"
          >
            {{ dataObj.applyRefundPrice }}
          </FormItem>
          <FormItem
            label="退款原因："
            prop="instructions"
            class="bumenModal-item"
          >
            {{ dataObj.refundReason }}
          </FormItem>
          <FormItem
            label="上传凭证图片："
            prop="instructions"
            class="bumenModal-item"
          >
            <img
              style="width:130px;height:150px;margin-right:20px;"
              v-for="item in dataObj.payReceiptImageList"
              :key="item"
              :src="item"
            />
          </FormItem>
        </Form>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" ghost type="success" @click="seeShow = false"
          >取消</Button
        >
        <Button class="btn sure" ghost type="success" @click="seeShow = false"
          >确定</Button
        >
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        auditRefundApplyForHospital,
        financialselectOrderList
    } from "../servers/api";
    import {
        stringify
    } from "querystring";
    export default {
        name: "alljigou",
        data() {
            return {
                alertTitle: "",
                alertTitleIshow2: false,
                alertTitleIshow: false,
                isiconfontshow: false,
                seeShow: false,
                cityList: [{
                    value: "0",
                    label: "全部支付状态"
                }, {
                    value: "4",
                    label: "已支付"
                }, {
                    value: "3",
                    label: "已取消"
                }, {
                    value: "5",
                    label: "已完成"
                }, {
                    value: "9",
                    label: "已退款"
                }, {
                    value: "1",
                    label: "待付款"
                }],
                jigouList: [{
                    value: "1",
                    label: "全部审核状态"
                }, {
                    value: "2",
                    label: "已通过审核"
                }, {
                    value: "3",
                    label: "未通过审核"
                }, {
                    value: "0",
                    label: "待审核"
                }],
                hospitalAuditMessage: "",
                selectJigouItem: "1",
                sliceIshhow: false,
                modaldata3: [{}],
                modaldata2: [{}],
                modaldata1: [{}],
                selectItem: "7",
                inputvalue: "",
                selectNum: 0,
                tableObj: {},
                pageNum: 1,
                pagesize: 20,
                data: [],
                selecTong: "2", //审核是否通过
                columns: [{
                    type: "selection",
                    width: 70,
                    align: "center"
                }, {
                    title: "订单编号",
                    minWidth: 120,
                    align: "center",
                    key: "orderNum",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "姓名",
                    width: 85,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "patientName"
                }, {
                    title: "性别",
                    width: 85,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "sex"
                }, {
                    title: "订单预留手机号",
                    width: 150,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "phone"
                }, {
                    title: "订单状态",
                    width: 110,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "orderStatus",
                    render: (h, params) => {
                        // orderStatus 订单状态(1-已提交未付款 2
                        // -未付款订单取消 3-手动取消 4-已付款可退款
                        // 5-已完成 6-订单异常 7-申请退款 8-退款中 9-已退款
                        // 10-部分退款 11-全额退款  12-已付款不可退款 13-退款失败
                        let item = params.row.orderStatus;
                        let name = "";
                        switch (item) {
                            case 1:
                                name = "待支付";
                                break;
                            case 2:
                                name = "已取消";
                                break;
                            case 3:
                                name = "已取消";
                                break;
                            case 4:
                                name = "已支付";
                                break;
                            case 5:
                                name = "已完成";
                                break;
                            case 6:
                                name = "订单异常";
                                break;
                            case 7:
                                name = "申请退款";
                                break;
                            case 8:
                                name = "退款中";
                                break;
                            case 9:
                                name = "已退款";
                                break;
                            case 10:
                                name = "已退款";
                                break;
                            case 11:
                                name = "已退款";
                                break;
                            case 12:
                                name = "已支付";
                                break;
                            case 13:
                                name = "退款失败";
                                break;
                        }
                        return h("div", {}, name);
                    }
                }, {
                    title: "预约日期",
                    width: 130,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "appointmentDate"
                }, {
                    title: "套餐名称",
                    minWidth: 220,
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "examSuiteName"
                }, {
                    title: "订单金额",
                    width: 110,
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    key: "orderPrice"
                }, {
                    title: "退款申请时间",
                    width: 160,
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    key: "applyTime"
                }, {
                    title: "审核说明",
                    minWidth: 180,
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    key: "hospitalAuditMessage",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    },
                                    domProps: {
                                        title: params.row.hospitalAuditMessage
                                    }
                                },
                                params.row.hospitalAuditMessage
                            )
                        ]);
                    }
                }, {
                    title: "操作",
                    key: "awssd",
                    align: "center",
                    width: 170,
                    fixed: "right",

                    render: (h, params) => {
                        let a = "#eee";
                        let b = "";
                        if (params.row.hospitalAuditStatus !== 2) {
                            a = "#7F7F7F";
                            b = "#53CAC3";
                        } else {
                            a = "rgb(191,191,212)";
                            b = "rgb(191,191,212)";
                        }
                        return h("div", [
                            h(
                                "div", {
                                    style: {
                                        height: "28px",
                                        display: "inline-block",
                                        "line-height": "30px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        width: "60px",
                                        cursor: "pointer",
                                        disabled: false,
                                        color: a,
                                        "border-color": b
                                    },
                                    on: {
                                        click: () => {
                                            if (params.row.hospitalAuditStatus !== 2) {
                                                this.chengeTable(params.row);
                                            }
                                        }
                                    }
                                },
                                "审核"
                            ),
                            h(
                                "div", {
                                    style: {
                                        width: "60px",
                                        height: "28px",
                                        "line-height": "27px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        background: "#fff",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        "margin-left": "8px",
                                        cursor: "pointer",
                                        display: "inline-block",
                                        color: "#7F7F7F"
                                    },
                                    on: {
                                        click: () => {
                                            this.seeItem(params.row);
                                        }
                                    }
                                },
                                "查看"
                            )
                        ]);
                    }
                }],
                isAsc: "",
                orderField: "",
                selectionList: [],
                ishow: false,
                status: "0", //结算状态 0 是全部结算状态 1 未结算 2 是已结算
                orderStatus: "7", //选中状态
                sliceorderNum: "",
                wtsAuditStatus: "", //空是全部、 0待审核 2 审核通过 3未通过
                dataObj: {}
            };
        },
        created() {
            this.financialselectOrderList();
        },
        methods: {
            seeItem(item) {
                //查看提交申请退款内容
                this.dataObj = item;
                this.dataObj.payReceiptImageList = this.dataObj.payReceiptImage.split(
                    ","
                );
                this.seeShow = true;
            },
            ok() {
                //审核 0不通过
                //确认退款
                auditRefundApplyForHospital({
                    orderNum: this.sliceorderNum,
                    hospitalAuditMessage: this.hospitalAuditMessage,
                    hospitalAuditStatus: this.selecTong
                }).then(res => {
                    if (res.data.code == 1) {
                        this.sliceIshhow = false;
                        this.isiconfontshow = false;
                        this.financialselectOrderList();
                    } else {
                        this.sliceIshhow = false;
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            chengeTable(params) {
                //点击审核按钮orderNum
                this.sliceorderNum = params.orderNum;
                this.sliceIshhow = true;
            },
            financialselectOrderList() {
                //列表接口
                this.isiconfontshow = true;
                let params = {
                    searchStr: this.inputvalue,
                    hospitalAuditStatus: this.wtsAuditStatus,
                    orderStatus: this.orderStatus, //订单状态
                    pageNum: this.pageNum,
                    pageSize: this.pagesize,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                financialselectOrderList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.data = res.data.data.list || [];
                        this.tableObj = res.data.data || {};
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            changeSelect(e) {
                //select选择订单状态
                if (e == 0) {
                    this.orderStatus = "";
                } else {
                    this.orderStatus = e;
                }
                this.financialselectOrderList();
            },
            changesort(item) {
                //排序
                this.isAsc = item.order;
                this.orderField = item.key;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.financialselectOrderList();
            },
            changecurrent(num) {
                //换页下一页
                this.pageNum = num;
                this.financialselectOrderList();
            },
            changepage(num) {
                //liaobiao切换请求条数
                this.pagesize = num;
                this.pageNum = 1;
                this.financialselectOrderList();
            },
            changeJigouSelect() {
                //选择机构审核状态
                if (this.selectJigouItem == 1) {
                    this.wtsAuditStatus = "";
                } else {
                    this.wtsAuditStatus = this.selectJigouItem;
                }
                this.financialselectOrderList();
            }
        }
    };
</script>

<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .ivu-date-picker[data-v-11c827ae] .ivu-picker-panel-sidebar {
        width: 98px;
    }
    
    .page-div-page /deep/,
    .ivu-page /deep/ {
        font-size: 13px;
    }
    
    .ivu-form /deep/ {
        .ivu-form-item-content {
            line-height: 40px;
        }
    }
    
    .modal-img-cont {
        width: 100%;
        position: relative;
        border: 1px solid #53cac3;
        height: 90px;
        border-radius: 5px;
        margin-top: 10px;
    }
    
    .position {
        position: absolute;
        top: 5px;
        font-size: 25px;
        color: #53cac3;
        right: 5px;
        cursor: pointer;
    }
    
    .modal-img-cont-title {
        display: inline-block;
        height: 100%;
        width: 150px;
        line-height: 90px;
        vertical-align: top;
    }
    
    .modal-img-cont-img {
        display: inline-block;
        width: 50px;
        height: 70px;
        margin: 5px 15px;
    }
    
    .modal-num {
        width: 100%;
        text-align: right;
        color: #53cac3;
        line-height: 10px;
    }
    
    .modal-span {
        width: 170px;
        display: inline-block;
        line-height: 17px;
        vertical-align: middle;
    }
    
    .i-icon {
        font-size: 25px;
        font-weight: 700;
        line-height: 30px;
        vertical-align: middle;
        color: #53cac3;
        margin-left: 3px;
        cursor: pointer;
        display: inline-block;
    }
    
    .bumenModal-item-left {
        width: 60px;
        color: #7f7f7f;
        display: inline-block;
        vertical-align: top;
    }
    
    .bumenModal-item-right {
        width: 150px;
        display: inline-block;
    }
    
    .bumenModal-item {
        //   padding-right: 10px;
    }
    
    .ivu-select-item {
        line-height: 20px;
        padding-left: 10px;
    }
    
    .table-cont {
        padding: 15px;
        margin: 55px 0 40px;
    }
    
    .modal-cont {
        width: 100%;
        max-height: 500px;
        overflow: hidden;
        overflow-y: visible;
        padding-bottom: 20px;
    }
    
    .lianxi {
        font-family: SimHei;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: visible;
        padding-bottom: 30px;
        color: #7f7f7f;
    }
    
    .input {
        width: 250px;
    }
    
    .title-title {
        width: calc(100% - 250px);
        height: 60px;
        line-height: 35px;
        position: fixed;
        top: 111px;
        z-index: 99;
        background: #fff;
        padding-top: 17px;
        left: 220px;
        padding-left: 15px;
        padding-bottom: 15px;
        .title {
            font-size: 16px;
            font-weight: 600;
            // margin-right: 15px;
            display: inline-block;
            height: 100%;
            position: relative;
            vertical-align: top;
            .title-absolute {
                position: absolute;
                top: 42px;
                left: 0px;
                width: 300px;
                height: 280px;
                background: #fff;
                box-shadow: 1px 1px 2px 1px rgb(224, 223, 223);
                z-index: 999;
                border-radius: 5px;
                ul {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    overflow-y: visible;
                    li {
                        display: inline-block;
                        line-height: 30px;
                        width: 100%;
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    li:hover {
                        background: rgb(225, 248, 247);
                    }
                }
            }
        }
        .input {
            width: 250px;
        }
        .ivu-btn-success {
            border-color: #53cac3;
            color: #7f7f7f;
            height: 30px;
        }
        .title-btn {
            float: right;
            margin-right: 15px;
            vertical-align: bottom;
            margin-top: 5px;
        }
    }
    
    .page-div {
        width: 100%;
        margin-top: 15px;
        position: fixed;
        background: #fff;
        width: calc(100% - 250px);
        height: 60px;
        z-index: 99;
        bottom: 0;
        padding-top: 15px;
        .page-div-left {
            float: left;
            padding: 5px 10px;
        }
        .page-div-lefts {
            border-right: 1px solid #d7d7d7;
            margin-right: 15px;
        }
        .page-div-page {
            float: right;
            margin-right: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/caiwu/shenhe.vue